import { useStyletron } from 'baseui';
import MetabaseIframe from '../../components/MetabaseIframe/MetabaseIframe';
export function QualityInsights({
  dashboardId,
  styles = {
    height: '100%',
    overflowY: 'auto',
    marginTop: '10px'
  }
}) {
  const [css] = useStyletron();
  return <div className={css(styles)}>
      <MetabaseIframe dashboardId={dashboardId} />
    </div>;
}
export default QualityInsights;